import {isDev, isInternal} from "../utils/env";

export const STRIPE_PUBLISHABLE_KEY = isInternal() || isDev()
    ? 'pk_test_51LmHkKGPaZ4c5kEDfuHZUAf94NNRNYdiLK2j2wFjM4XchXo7ls9S0imO2OuLZSV91NeEir7I4NlzwrfqED2qkYYi00n4GyoffL'
    : 'pk_live_51LmHkKGPaZ4c5kEDU0XVinWo1tuoNXMGQDVUbY9L8IOd8G33eTQpVG7SZDSxUCsLhInq20ZcRnWcu3pKGqg2rE0V00rY3lpKrx';
